import React from 'react';
import { FormHeader, IconNotificationSuccess } from '@snsw/react-component-library';
import styled from 'styled-components';
import { useApplicationConfig } from '../../../store';

const FormHeaderWrapper = styled.div`
    margin-bottom: -2.5rem;
`;

export const HeaderNoStepper = (props: any) => {
    const config = useApplicationConfig();
    return (
        <FormHeaderWrapper>
            <FormHeader
                label={ config.appTitle }
                title={ <><IconNotificationSuccess size='md' /> Application submitted for assessment</> }
            />
        </FormHeaderWrapper>
    );
};

export default HeaderNoStepper;
